import {Fragment} from "preact";
import {Dialog, Transition} from '@headlessui/react';
import Content from "./Content";
import {useLegacySatisfactionSurvey} from "./useLegacySatisfactionSurvey";
import {useAppContext} from "../../contexts";

const LegacySatisfactionSurvey = (props) => {
    // Destructured props
    const {data} = props;

    // Component logic data
    const componentProps = useLegacySatisfactionSurvey({
        data
    });

    // Destructured component logic data
    const {
        open,
        setOpen
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    return (
        <Transition.Root show={open} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={setOpen}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >
                            <Dialog.Panel className={`relative transform rounded-xl text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[420px] px-10 py-14 ${highContrast ? "grayBackground" : "bg-light-gray"}`}>
                                <Content
                                    setOpen={setOpen}
                                    urlPath={data.url}
                                />
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}

export default LegacySatisfactionSurvey;
